import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormatHexDataPipe } from './format-hex-data.pipe';


@NgModule({
  declarations: [
    FormatHexDataPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    FormatHexDataPipe,
  ],
})
export class FormatHexDataModule { }